require('../brokerStocksPurchaseOrderWizard.scss');
 
// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');

// @constants
const { FIRST_STEP, SECOND_STEP, DATE_FORMAT_ES, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const CLASS_NAME = 'broker-stocks-purchase-order-view';

class BrokerStocksPurchaseOrderSidebar extends React.Component {

    render () {
        const { immBrokerStocksPurchaseOrder } = this.props;
        const contractId = CHARGE_ACCOUNT_PREFIX + immBrokerStocksPurchaseOrder.getIn(['contract', 'product']) + immBrokerStocksPurchaseOrder.getIn(['contract', 'number']);
        const associatedAccountBalance = immBrokerStocksPurchaseOrder.getIn(['associatedAccount', 'balance']);
        const associatedAccountCurrency = immBrokerStocksPurchaseOrder.getIn(['associatedAccount', 'balance', 'currency']);
        const firstStepAmount = immBrokerStocksPurchaseOrder.getIn(['steps', FIRST_STEP, 'amount']);
        const plainAmountObject = getPlainAmountObject(associatedAccountBalance);
        const language = getLanguage();
        let amountInformation;

        // Only display end date and titles amount in second step
        if (immBrokerStocksPurchaseOrder.get('visibleStep') == SECOND_STEP + 1) {
            if (firstStepAmount) {
                amountInformation = (
                    <div className={`${CLASS_NAME}__sidecolumn-information`}>
                        <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                            <FormattedText
                                value="stocksPurchaseOrder-amount"
                                injectedStrings={[associatedAccountCurrency]}
                                format="uppercase"
                            />
                        </h5>
                        <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                            {firstStepAmount}
                        </div>
                    </div>
                );
            }
        }

        return (
            <OKSectionBox>
                <h4><FormattedText value="stocksPurchaseOrder-value" /></h4>

                <div className={`${CLASS_NAME}__sidecolumn-header`}>
                    <h3 className={`${CLASS_NAME}__sidecolumn-title`}>{immBrokerStocksPurchaseOrder.getIn(['operation', 'descriptionValue'])}</h3>
                    <h5 className={`${CLASS_NAME}__sidecolumn-header-subtitle ${CLASS_NAME}__lighter-fg`}>
                        {immBrokerStocksPurchaseOrder.getIn(['operation', 'stockExchange'])}
                    </h5>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="stocksPurchaseOrder-contract"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerStocksPurchaseOrder.get('walletAccountType')}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        <FormattedText
                            value="stocksPurchaseOrder-contractNumber"
                            injectedStrings={[contractId]}
                        />
                    </div>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="stocksPurchaseOrder-owner"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerStocksPurchaseOrder.get('owner')}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        <FormattedText value="stocksPurchaseOrder-authorized" />
                    </div>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="stocksPurchaseOrder-associatedAccount"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {immBrokerStocksPurchaseOrder.getIn(['associatedAccount', 'number'])}
                    </div>
                    <div className={`${CLASS_NAME}__lighter-fg`}>
                        (
                        <FormattedText
                            value="stocksPurchaseOrder-associatedAccountBalance"
                        />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                        )
                    </div>
                </div>

                <div className={`${CLASS_NAME}__sidecolumn-information`}>
                    <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                        <FormattedText
                            value="broker-rightsBuySidebarDeadlineLabel"
                            format="uppercase"
                        />
                    </h5>
                    <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                        {DateHelper.buildFormattedDate(immBrokerStocksPurchaseOrder.getIn(['operation', 'endDate']), DATE_FORMAT_ES)}
                    </div>
                </div>

                {amountInformation}
            </OKSectionBox>
        );
    }
}

BrokerStocksPurchaseOrderSidebar.propTypes = {
    immBrokerStocksPurchaseOrder: PropTypes.object.isRequired,
};

module.exports = BrokerStocksPurchaseOrderSidebar;